export const orderStateEnum = [
    {
        stateId: "INIT",
        stateName: "初始状态"
    },
    {
        stateId: "NORMAL",
        stateName: "正常"
    },
    {
        stateId: "UNPAID",
        stateName: "待支付"
    },
    {
        stateId: "PAID",
        stateName: "已支付"
    },
    {
        stateId: "WAIT_ACCEPT",
        stateName: "待接单"
    },
    {
        stateId: "PREPARING",
        stateName: "备餐中"
    },
    {
        stateId: "READY_FOR_PICKUP",
        stateName: "待取餐"
    },
    {
        stateId: "DELIVERING",
        stateName: "配送中"
    },
    {
        stateId: "CANCELLED",
        stateName: "已取消"
    },
    {
        stateId: "CLOSED",
        stateName: "已关闭"
    },
    {
        stateId: "COMPLETED",
        stateName: "已完成"
    },
    {
        stateId: "REFUNDING",
        stateName: "退款中"
    },
    {
        stateId: "PARTIAL_REFUNDED",
        stateName: "部分退款"
    },
    {
        stateId: "REFUNDED",
        stateName: "已退款"
    },
    {
        stateId: "REGISTERED",
        stateName: "已报名"
    },
    {
        stateId: 'AVAILABLE',
        stateName: '待使用'
    }
]

export const orderTriggerEnum = [
    {
        stateId: "SUBMIT_ORDER",
        stateName: "提交订单"
    },
    {
        stateId: "PAYMENT_SUCCESS",
        stateName: "支付成功"
    },
    {
        stateId: "PAYMENT_TIMEOUT",
        stateName: "支付超时"
    },
    {
        stateId: "CLOSE_ORDER",
        stateName: "主动关闭订单"
    },
    {
        stateId: "PREPARATION_COMPLETE",
        stateName: "备餐完成"
    },
    {
        stateId: "CANCEL_ORDER",
        stateName: "取消订单"
    },
    {
        stateId: "CUSTOMER_PICKUP",
        stateName: "顾客取餐"
    },
    {
        stateId: "RIDER_PICKUP",
        stateName: "骑手取餐"
    },
    {
        stateId: "ORDER_DELIVERED",
        stateName: "订单送达"
    },
    {
        stateId: "REQUEST_REFUND",
        stateName: "申请退款"
    },
    {
        stateId: "REFUND_SUCCESS",
        stateName: "退款成功"
    }
]